import i18next from 'i18next';

import { GENERIC_MODAL_CLOSE_BUTTON } from '@commons/Modals/GenericModal/genericModalActions';

import StatusLegendModal from './StatusLegendModal';

export const getStatusLegendModalParams = () => ({
  type: 'info',
  width: '420px',
  height: 'auto',
  icon: '/images/inpulse/info-dgrey-small.svg',
  title: i18next.t('ADMIN.FTP_DEBUG.STATUS_LEGEND_MODAL_TITLE'),
  component: StatusLegendModal,
  actions: [GENERIC_MODAL_CLOSE_BUTTON()],
});
